<script setup lang="ts">
import { type Component, computed } from 'vue';

import NarrowableDashboardReport from '@/components/VisionAi/chat-panel-components/widgets/NarrowableDashboardReport.vue';
import type { VisionWidget, WidgetType } from '@/components/VisionAi/widgets/visionWidget.types';

const { widgets = [], narrowMode = false } = defineProps<{
  widgets?: VisionWidget[];
  narrowMode?: boolean;
}>();

const emit = defineEmits<{
  expand: [];
}>();

const WIDGET_COMPONENT_MAP: Partial<Record<WidgetType, Component>> = {
  legacy_dashboards_report: NarrowableDashboardReport,
};

const resolvedWidgets = computed(() =>
  widgets
    .map((widget, index) => ({
      component: WIDGET_COMPONENT_MAP[widget.type],
      data: widget.data,
      key: `unified-widget-${index}`,
    }))
    .filter((entry) => entry.component),
);
</script>

<template>
  <component
    :is="entry.component"
    v-for="entry in resolvedWidgets"
    :key="entry.key"
    :widget-data="entry.data"
    :narrow-mode="narrowMode"
    @expand="emit('expand')"
  />
</template>
